import cn from 'classnames';

import styles from '~/style/aigallery/component.module.less';

export const ArrowBtn = ({data}) => {
    const {link, text, primary = true, secondary = false, third = false, trackInfo, className = null} = data;

    return (
        <a
            className={cn(styles['arrow-btn'], {
                [styles.primary]: primary && !secondary && !third,
                [styles.secondary]: secondary,
                [styles.third]: third
            })}
            href={link}
            target="_blank"
            {...trackInfo}
        >
            <span className={`${styles['arrow-btn-text']} ${className}`} data-text={text}>
                {text}
            </span>
        </a>
    );
};

export const ArrowSpanBtn = ({data}) => {
    const {text, primary = true, secondary = false, third = false} = data;
    return (
        <span
            className={cn(styles['arrow-btn'], {
                [styles.primary]: primary && !secondary && !third,
                [styles.secondary]: secondary,
                [styles.third]: third
            })}
        >
            <span className={styles['arrow-btn-text']} data-text={text}>
                {text}
            </span>
        </span>
    );
};

export const NormalBtn = ({data}) => {
    const {link, text, btnType = 'small', className = null, trackInfo, cns} = data;
    return cns === 'disabled' ? (
        <span className={cn(`${styles['normal-btn-small']} ${className}`, {[styles[cns]]: cns})}>
            <div className={styles['normal-btn-big-text']} data-text={text}>
                {data.text}
            </div>
        </span>
    ) : btnType === 'small' ? (
        <a
            href={link}
            target="_blank"
            {...trackInfo}
            className={cn(`${styles['normal-btn-small']} ${className}`, {[styles[cns]]: cns})}
        >
            <div className={styles['normal-btn-small-text']} data-text={text}>
                {text}
            </div>
        </a>
    ) : (
        <a href={link} className={`${styles['normal-btn-big']} ${className}`} target="_blank" {...trackInfo}>
            <div className={styles['normal-btn-big-text']} data-text={text}>
                {data.text}
            </div>
        </a>
    );
};

export const NormalSpanBtn = ({data}) => {
    const {text} = data;
    return (
        <span className={styles['normal-btn-small']}>
            <div className={styles['normal-btn-small-text']} data-text={text}>
                {text}
            </div>
        </span>
    );
};
